/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Delivery_Log_EmptyInputs */

const he_account_delivery_log_empty = /** @type {(inputs: Account_Delivery_Log_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`לא נמצאו ניסיונות שליחה אחרונים.`)
};

const en_account_delivery_log_empty = /** @type {(inputs: Account_Delivery_Log_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No recent notification attempts.`)
};

/**
* | output |
* | --- |
* | "No recent notification attempts." |
*
* @param {Account_Delivery_Log_EmptyInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const account_delivery_log_empty = /** @type {((inputs?: Account_Delivery_Log_EmptyInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Delivery_Log_EmptyInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_account_delivery_log_empty(inputs)
	return en_account_delivery_log_empty(inputs)
});